import UserProfileModule from "@/modules/UserProfile";

function EditUserProfilePage() {
  return <UserProfileModule type="edit" />;
}

export default EditUserProfilePage;
